import React from 'react';
import { deleteAppointment, createAppointment } from '../reducers/calendar';
import { connect } from "react-redux";
import { GlassModal, GlassModalHeader, GlassModalBody } from './GlassModal';
import TemplateBuilder from './TemplateBuilder'
import Select from './SelectComponent'
import DateEditComponent from './DateEdit'
import SpinnerView from './spinner/spinner-view';
import { selectInvoice } from '../reducers/invoices';
import Invoice from './invoice';
import moment from 'moment'
import Alert from "./glass/GlassAlert";
import { colors } from '../theme';
import SwitchEdit from './SwitchEdit';
import CommentComponent from './CommentComponent';
import '../styles/appointment-glass.css';

const getItemStatus = (item) => {
    return (item.hasSchedule == undefined || item.hasSchedule == true) ? (item.status ?? 'Scheduled') : 'Unscheduled';
}

const AddAppointmentComponent = ({
    onChangeText,
    updateDiscount,
    updateLineItems,
    updateClient,
    dispatchDeleteAppointment,
    dispatchSelectInvoice,
    updateshowAdd,
    templates,
    saveAppointment, error, appointment, navigation, company }) => {

    const [showInvoice, setShowInvoice] = React.useState('');

    let selectedTemplate = templates.find(i => i.name == appointment.appointmentType);
    if (!selectedTemplate) {
        if (templates.length > 0) {
            selectedTemplate = templates[0];
            appointment.appointmentType = selectedTemplate.name;
        }
    }

    const users = (company && company.users) ? company.users.filter(u => !u.disabled) : [];
    const log = appointment && appointment.log
        ? [...appointment.log].sort((a, b) => (moment(a.d) > moment(b.d)) ? -1 : 1)
        : null;

    // Comments live in the right rail (above history), not inline in the form.
    const commentsComp = (selectedTemplate && selectedTemplate.components)
        ? selectedTemplate.components.find(c => c.type === 'comments')
        : null;

    return (
        <div>
            {!!error && <div style={{ marginBottom: 12, fontWeight: 600, fontSize: 14, color: 'var(--danger, #DA4A4F)' }}><i className="fas fa-exclamation-circle" style={{ marginRight: 6 }}></i>{error}</div>}

            {showInvoice && <section className="content">
                <div className="card-body">
                    <Invoice updateshowAdd={setShowInvoice} orgAppointment={appointment} />
                </div>
            </section>}

            {!showInvoice && appointment && <>
                {/* Type picker — only while creating */}
                {!appointment._id && templates.length > 1 && (
                    <div className="apt-type-seg">
                        {templates.map((t, key) => (
                            <button key={key} type="button"
                                className={appointment.appointmentType == t.name ? 'on' : ''}
                                onClick={() => onChangeText('appointmentType', t.name)}>
                                <i className={t.icon || 'far fa-calendar'}></i> {t.name}
                            </button>
                        ))}
                    </div>
                )}

                <div className="apt-layout">
                    {/* MAIN — the template-driven form */}
                    <div className="apt-main">
                        {selectedTemplate && <TemplateBuilder setShowInvoice={setShowInvoice} onChangeText={onChangeText} navigation={navigation} obj={appointment} template={selectedTemplate} />}
                    </div>

                    {/* RAIL — schedule, assignment, history */}
                    <div className="apt-rail">
                        <div className="apt-railcard">
                            <div className="apt-rail-title"><i className="far fa-calendar"></i> Schedule</div>
                            <DateEditComponent
                                viewOnly={false}
                                key={'startDate'}
                                header={'Schedule date'}
                                onChangeText={onChangeText}
                                prop={'startDate'}
                                value={appointment.startDate}
                            />
                            <SwitchEdit
                                prop={'isAllDayEvent'}
                                onChangeText={onChangeText}
                                viewOnly={false}
                                header={'All day'}
                                value={appointment.isAllDayEvent} />
                            {selectedTemplate && selectedTemplate.statuses && <Select
                                header="Status"
                                options={selectedTemplate.statuses.map((u) => u.name)}
                                onChangeText={onChangeText}
                                prop="status"
                                value={getItemStatus(appointment)}
                            />}
                            {users.length > 0 && <div className="apt-rail-field">
                                <label>Assignee</label>
                                <select className="form-control" value={appointment.userId || ''}
                                    onChange={(e) => { if (e.target.value) onChangeText('userId', e.target.value); }}>
                                    <option value="" disabled>Select a user…</option>
                                    {users.map(u => <option key={u.userId} value={u.userId}>{u.name}</option>)}
                                </select>
                            </div>}
                            <div className="apt-rail-created">Created {moment(appointment.createdDate).format('DD MMM YYYY')}</div>
                        </div>

                        {commentsComp && (
                            <CommentComponent
                                prop={commentsComp.prop}
                                onChangeText={onChangeText}
                                value={appointment[commentsComp.prop]}
                            />
                        )}

                        {log && log.length > 0 && <div className="apt-railcard">
                            <div className="apt-rail-title"><i className="fas fa-history"></i> History</div>
                            <div className="apt-hist">
                                {log.map((l, li) => <div className="apt-hist-item" key={li}>
                                    <div className="s">{l.s}
                                        {l.location && <a href={'https://www.google.com/maps/place/' + l.location.latitude + ', ' + l.location.longitude} target="_blank" rel="noopener noreferrer" title="Open location"><i className="fas fa-map-marker-alt"></i></a>}
                                    </div>
                                    <div className="d">{moment(l.d).format('DD MMM YYYY HH:mm')}</div>
                                </div>)}
                            </div>
                        </div>}
                    </div>
                </div>

                <div className="apt-footer">
                    <button data-test="button" type="button" className="btn btn-secondary" onClick={() => { updateshowAdd(false) }} >Cancel</button>
                    <button data-test="button" type="button" className="btn btn-primary" onClick={() => {
                        Alert.fire({
                            title: 'Save the changes?',
                            showDenyButton: true,
                            showCancelButton: false,
                            confirmButtonText: 'Save',
                            denyButtonText: `Cancel`,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                saveAppointment(updateshowAdd);
                            }
                        })
                    }} ><i className="fas fa-save" style={{ marginRight: 6 }}></i>Save</button>
                </div>
            </>}
        </div>
    )
};

class AddAppointmentScreen extends React.Component {
    setAppointment = () => {
        const start = moment();
        const remainder = 30 - (start.minute() % 30);
        const dateTime = moment(start).add(remainder, "minutes");

        if (this.props.orgAppointment) return { ...this.props.orgAppointment };

        return {
            hasSchedule: false,
            isAllDayEvent: true,
            sendClientReminder: false,
            startDate: dateTime.toISOString(),
            appointmentType: this.props.templates[0].name,
            endDate: dateTime.add(30, "minutes").toISOString()
        };
    }

    state = {
        appointment: this.setAppointment(),
        index: undefined
    }

    saveAppointment = (updateshowAdd) => {
        this.props.dispatchCreateAppointment(this.state.appointment, updateshowAdd);
    }

    compare = () => {
        return JSON.stringify(this.state.appointment) === JSON.stringify(this.props.orgAppointment);
    }

    onChangeText = (key, value) => {
        let newAppointment = {
            ...this.state.appointment,
            [key]: value
        };

        if (key === 'status') {
            if (value === 'Please select') {
                delete newAppointment.status;
                newAppointment.hasSchedule = false;
            } else {
                newAppointment.hasSchedule = true;
            }
        }

        this.setState({
            ...this.state,
            appointment: {
                ...newAppointment
            }
        });
    }

    updateLineItems = (items) => {
        this.setState({
            appointment: {
                ...this.state.appointment,
                lineItems: { ...items }
            }
        });
    }

    updateDiscount = (discount) => {
        this.setState({
            appointment: {
                ...this.state.appointment,
                discount
            }
        });
    }

    updateClient = (entity) => {
        this.onChangeText('entityId', entity);
    }

    requestClose = () => {
        if (this.compare()) {
            this.props.updateshowAdd(false);
            return;
        }
        Alert.fire({
            title: 'Save the changes?',
            text: 'You have unsaved changes to this appointment.',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Save',
            denyButtonText: 'Discard',
        }).then((result) => {
            if (result.isConfirmed) this.saveAppointment(this.props.updateshowAdd);
            else if (result.isDenied) this.props.updateshowAdd(false);
        });
    };

    render() {
        const appointment = this.state.appointment;
        const template = (this.props.templates || []).find(t => t.name == appointment.appointmentType);
        const scheduled = getItemStatus(appointment) !== 'Unscheduled';

        return (
            <GlassModal isOpen={true} size="xl" toggle={this.requestClose}>
                <GlassModalHeader toggle={this.requestClose}>
                    <span className="apt-head">
                        <span className="apt-head-ico" style={{ background: (template && template.color) || 'var(--primary, #0DA1B2)' }}>
                            <i className={(template && template.icon) || 'far fa-calendar'}></i>
                        </span>
                        <span className="apt-head-title">{appointment._id ? ((template && template.name) || 'Appointment') : `New ${(template && template.name) || 'appointment'}`}</span>
                        {appointment.appointmentNumber && <span className="apt-head-num">#{appointment.appointmentNumber}</span>}
                        <span className={`apt-status-pill ${scheduled ? 'sched' : 'unsched'}`}>
                            <i className="fas fa-circle"></i> {getItemStatus(appointment)}
                        </span>
                    </span>
                </GlassModalHeader>
                <GlassModalBody>
                    <SpinnerView showSpinner={this.props.loading} />
                    <SpinnerView showSpinner={this.props.loadingI} />
                    <AddAppointmentComponent
                        compare={this.compare}
                        saveAppointment={this.saveAppointment}
                        onChangeText={this.onChangeText}
                        appointment={this.state.appointment}
                        updateLineItems={this.updateLineItems}
                        updateDiscount={this.updateDiscount}
                        updateClient={this.updateClient}
                        {...this.props} />
                </GlassModalBody>
            </GlassModal>
        );
    }
}

const mapStateToProps = state => ({
    error: state.calendar.error,
    orgAppointment: state.calendar.appointment,
    entities: state.entities.entities,
    company: state.companies.company,
    loading: state.calendar.loading,
    loadingI: state.invoices.loading,
    templates: state.calendar.appointmentTypes
})

const mapDispatchToProps = {
    dispatchCreateAppointment: (appointment, updateshowAdd) => createAppointment(appointment, updateshowAdd),
    dispatchDeleteAppointment: (appointment, navigate) => deleteAppointment(appointment, navigate),
    dispatchSelectInvoice: (id) => selectInvoice(id),
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAppointmentScreen)
